import React from 'react';

import Link from 'next/link';

import * as styles from './index.module.scss';

const CitiesList = (props) => {
  const { state } = props;
  const { abbreviation, label, cities } = state;

  return (
    <div className={`${styles['cities-list-container']}`}>
      <div className="container">
        <h3>All Cities in {label}</h3>
        <ul className={styles['city-links-container']}>
          {cities.map((city) => (
            <li key={city.toLowerCase()}>
              <Link href={`/us/${abbreviation.toLowerCase()}/${city.toLowerCase()}`}>{city} Pros</Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default CitiesList;
